export default __webpack_public_path__ + "static/media/logo-new.cfdd3e27.svg";